import { createFileRoute } from "@tanstack/react-router";
import OwnerPricingPage from "@/pages/OwnerPricingPage";

export const Route = createFileRoute("/_owner/owner/pricing")({
  component: OwnerPricingPage,
});
